import { render, staticRenderFns } from "./MyReviewDatails.vue?vue&type=template&id=2845f3fc&scoped=true"
import script from "./MyReviewDatails.vue?vue&type=script&lang=js"
export * from "./MyReviewDatails.vue?vue&type=script&lang=js"
import style0 from "./MyReviewDatails.vue?vue&type=style&index=0&id=2845f3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845f3fc",
  null
  
)

export default component.exports